/* JOLI POT, formulaire produit du configurateur (assets/jp-produit-formulaire.js)
   Chargé uniquement par snippets/jp-produit-formulaire.liquid (fiche « Personnalise ton pot »).
   Rôle : ce que faisait l'ancien thème pour ce formulaire.
   1. Options choisies -> variante : met à jour le champ id, le prix, le bouton (disponible ou non).
   2. Prévient la galerie native de Prestige (événement variant:change) pour afficher la photo de la variante.
   3. Boutons + et - de la quantité.
   4. Affiche le champ de texte de la carte à planter quand la case est cochée.
   5. Empêche l'envoi classique du formulaire : l'ajout au panier est géré par le configurateur. */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form[data-jp-produit]');
    var dataEl = document.querySelector('[data-jp-produit-json]');
    if (!form || !dataEl || form.dataset.jpInit) return;
    form.dataset.jpInit = '1';

    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants || [];
    var champId = form.querySelector('[name="id"]');
    var courante = variants.filter(function (v) { return String(v.id) === String(champId && champId.value); })[0] || null;

    function formater(centimes) {
      var format = data.moneyFormat || '{{amount_with_comma_separator}} €';
      var n = (centimes / 100).toFixed(2);
      var avecVirgule = n.replace('.', ',');
      var montant = format
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(centimes / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, avecVirgule)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(centimes / 100)))
        .replace(/\{\{\s*amount\s*\}\}/, n);
      return montant.replace(/[.,]00(?=\D|$)/, '');
    }

    function selection() {
      var choix = {};
      form.querySelectorAll('.SizeSwatch__Radio:checked, .ColorSwatch__Radio:checked').forEach(function (r) {
        choix[r.dataset.optionPosition] = r.value;
      });
      return choix;
    }

    function trouverVariante() {
      var choix = selection();
      return variants.filter(function (v) {
        return (!choix['1'] || v.option1 === choix['1']) &&
          (!choix['2'] || v.option2 === choix['2']) &&
          (!choix['3'] || v.option3 === choix['3']);
      })[0] || null;
    }

    function majBouton(v) {
      var bouton = form.querySelector('.ProductForm__AddToCart');
      if (!bouton) return;
      var dispo = !!(v && v.available);
      var prix = bouton.querySelector('[data-money-convertible]');
      /* Mise à jour en place : le configurateur garde une référence vers le prix affiché dans le bouton */
      if (dispo && prix) {
        prix.textContent = formater(v.price);
      } else if (dispo) {
        bouton.innerHTML = '<span>' + data.texteAjouter + '</span><span class="Button__SeparatorDot"></span><span data-money-convertible>' + formater(v.price) + '</span>';
      } else {
        bouton.textContent = data.texteRupture;
      }
      bouton.disabled = !dispo;
      if (dispo) bouton.setAttribute('data-action', 'add-to-cart'); else bouton.removeAttribute('data-action');
    }

    function appliquer(v) {
      var avant = courante;
      courante = v;
      if (champId && v) champId.value = v.id;
      var prix = document.querySelector('.jp-produit-meta .ProductMeta__Price');
      if (prix && v) prix.textContent = formater(v.price);
      majBouton(v);
      if (v && (!avant || avant.id !== v.id)) {
        form.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { formId: form.getAttribute('id'), variant: v, previousVariant: avant }
        }));
      }
    }

    form.addEventListener('change', function (e) {
      var cible = e.target;
      if (cible.matches && cible.matches('.SizeSwatch__Radio, .ColorSwatch__Radio')) appliquer(trouverVariante());
      if (cible.id === 'add-seed-card') {
        var boite = document.getElementById('seed-card-message');
        if (boite) boite.style.display = cible.checked ? 'block' : 'none';
      }
    });

    form.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.QuantitySelector__Button') : null;
      if (!b) return;
      var champ = form.querySelector('.QuantitySelector__CurrentQuantity');
      var q = parseInt(champ.value, 10) || 1;
      q = b.dataset.action === 'decrease-quantity' ? Math.max(1, q - 1) : q + 1;
      champ.value = q;
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Touche Entrée dans un champ : on passe par le bouton, que le configurateur intercepte */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bouton = form.querySelector('.ProductForm__AddToCart');
      if (bouton && !bouton.disabled) bouton.click();
    });

    appliquer(trouverVariante() || courante);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 6. Garde signature (ajout du 23/10/2026, suite commande #3687 partie avec « Signature sur le pot » vide).
   Passe AVANT le configurateur (écoute en phase de capture sur window) :
   a. les champs de personnalisation remplis seulement d'espaces sont vidés, le configurateur ne les envoie donc pas ;
   b. si la case « Ajouter un prénom ou une signature » est cochée et que le champ est vide, l'ajout au panier est bloqué
      avec un message clair. */
(function () {
  'use strict';
  var MESSAGE = "Merci d'indiquer le prénom ou la signature à écrire sous le cœur, ou de décocher la case si vous n'en souhaitez pas.";

  function retirerErreur() {
    var e = document.getElementById('jp-sig-erreur');
    if (e) e.remove();
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ProductForm__AddToCart') : null;
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;

    form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (c) {
      if (c.type === 'checkbox' || c.type === 'radio' || c.type === 'hidden') return;
      if (c.value !== c.value.trim()) c.value = c.value.trim();
    });

    retirerErreur();
    var caseSig = document.getElementById('jp-prenom-check');
    var sig = document.getElementById('jp-ap-sig');
    if (caseSig && caseSig.checked && sig && !sig.value.trim()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var p = document.createElement('p');
      p.id = 'jp-sig-erreur';
      p.className = 'jp-erreur';
      p.setAttribute('role', 'alert');
      p.style.cssText = 'color:#ad523f;margin:6px 0 0;font-size:.95em';
      p.textContent = MESSAGE;
      sig.insertAdjacentElement('afterend', p);
      sig.focus();
    }
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'jp-ap-sig' && e.target.value.trim()) retirerErreur();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'jp-prenom-check' && !e.target.checked) retirerErreur();
  });
})();
